//@author: travis
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25CopyObjectComponent } from "./s25.copy.object.component";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { S25ContactInfoModule } from "../s25-contact-info/s25.contact.module";
import { S25PrintObjectReportComponent } from "./s25.print.object.report.component";
import { S25DocumentManagementModule } from "../system-settings/document-management/s25.document.management.module";
import { S25ReportComponent } from "../s25-report/s25.report.component";
import { CreateTodoComponent } from "../s25-task/s25.create.task.component";
import { S25DatepickerModule } from "../s25-datepicker/s25.datepicker.module";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { S25FadingSuccessMsgComponent } from "../s25-fading-success-msg/s25.fading.success.msg.component";
import { S25ListDataComponent } from "../s25-table-list/s25.list.data.component";
import { S25QuickSearchComponent } from "../s25-quick-search/s25.quick.search.component";
import { S25SubscribeComponent } from "./s25.subscribe.component";
import { S25EmailEventComponent } from "./s25.email.event.component";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { FileUploadModule } from "../s25-file-upload/s25.file.upload.module";
import { S25RichTextEditorModule } from "../s25-rich-text-editor/s25.rich.text.editor.module";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { S25ReportFileTypeComponent } from "../../standalone/s25.report.file.type.component";
import { S25EditOwnershipComponent } from "./s25.edit.ownership.component";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25ObjectDetailsService } from "../object-details/s25.object.details.service";

@NgModule({
    declarations: [
        S25CopyObjectComponent,
        S25PrintObjectReportComponent,
        CreateTodoComponent,
        S25SubscribeComponent,
        S25EmailEventComponent,
        S25EditOwnershipComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        S25EditableModule,
        S25ItemModule,
        S25LoadingInlineModule,
        S25ContactInfoModule,
        S25DocumentManagementModule,
        S25IconComponent,
        S25ReportComponent,
        S25DatepickerModule,
        S25MultiselectModule,
        S25ButtonComponent,
        S25FadingSuccessMsgComponent,
        S25CheckboxModule,
        FileUploadModule,
        S25RichTextEditorModule,
        S25ModalModule,
        S25ReportFileTypeComponent,
        S25DropdownPaginatedModule,
    ],
    providers: [
        S25CopyObjectComponent,
        S25PrintObjectReportComponent,
        CreateTodoComponent,
        S25SubscribeComponent,
        S25EmailEventComponent,
        S25ObjectDetailsService,
        S25EditOwnershipComponent,
        S25ListDataComponent,
        S25QuickSearchComponent,
        S25EditableModule,
    ],
    exports: [
        S25CopyObjectComponent,
        S25PrintObjectReportComponent,
        CreateTodoComponent,
        S25SubscribeComponent,
        S25EmailEventComponent,
        S25EditOwnershipComponent,
    ],
})
export class S25MoreActionsModule {
    constructor() {}
}
